/**
 * Created by: cparaschiv
 * Date: 24.10.2013, 10:47
 */

TS.ns('TS.UI');

(function(window, undefined) {
    'use strict';

    var baseCls = 'grid-cell';

    TS.UI.CellRenderer = {

        getCellTemplate: function(field, isPopup){
            return function(dataItem){
                var cell,
                    cls,
                    cellContent;

                cellContent = TS.UI.Renderers.list._default.getCellContent(field, dataItem, isPopup);
                cls = baseCls + ' ' + (TS.UI.Renderers.list._default.getCellClass(field, dataItem) || '');
                cell = '<div class="' + cls + '">' + cellContent + '</div>';

                return cell;
            }
        },

        getKendoCellTemplate: function(field, isPopup){
            return function(dataItem){
                var defRenderer = TS.UI.Renderers.grid._default,
                    _getCellContent, _getCellClass,
                    renderer,
                    cellContent,
                    cell,
                    cls;

                if (field.renderer) {
                    renderer = TS.UI.Renderers.grid[field.renderer] || defRenderer;
                }

                _getCellContent = (renderer && renderer.getCellContent) || defRenderer.getCellContent;
                cellContent = _getCellContent(field, dataItem, isPopup) || '';

                _getCellClass = (renderer && renderer.getCellClass) || defRenderer.getCellClass;
                cls = baseCls + ' ' + (_getCellClass(field, dataItem) || '');

                cell = '<div class="' + cls + '">' + cellContent + '</div>';

                return cell;
            }
        }
    }
})(this);

